import angular from 'angular';

import * as actions from '../store/actions';

/**
 * @ngdoc function
 * @name myConsultApp.controller:uploadReceipt
 * @description
 * # uploadReceipt
 * Controller of the myConsultApp
 */

const mapStateToScope = (state) => {
  return {
    invoice: state.invoice,
    user: state.user.user,
    pets: state.pet.userPets,
  };
};

angular
  .module('myConsultApp')
  .controller('uploadReceipt', ($scope, $ngRedux, $location, crumble) => {
    if ($scope.isAdminUser || $scope.isSuperUser) {
      $location.path('/admin');
    }
    if (!$scope.isRewardsSubscribed && !$scope.isAdminUser) {
      $location.path('/find-a-pet');
    } else {
      $scope.crumble = crumble;
      crumble.update();

      // Init scope
      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      };
      $scope.init();

      $scope.$on('$destroy', () => {
        $scope.unsubscribe();
      });
    }
  });
